import { Component, HostBinding, Input } from '@angular/core';
import { OAuthService } from 'angular-oauth2-oidc';
import { Banner, ISitemap } from "@neb/lit-storybook"
import "@neb/lit-storybook";

@Component({
  selector: 'gems-wrapper',
  templateUrl: 'gems-wrapper.component.html',
  styleUrls: ['gems-wrapper.component.less'],
  standalone: false
})
export class GemsWrapperComponent {
  @Input({ required: true }) siteMap!: ISitemap;
  @Input() unreadMessageCount: number = 0;
  @Input() isAdminViewMode: boolean = false;
  @Input() banners: Banner[] = [];

  @HostBinding('class') class = 'wrapper';

  constructor(
    private oauthService: OAuthService
  ) { }

  logout() {
    this.oauthService.logOut();
  }
}
